import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export default function SubHero({
  overline,
  title,
  description,
  image,
  primaryCta,
  secondaryCta,
}) {
  const goTo = (href) => {
    if (!href) return;
    if (href.startsWith("#")) {
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <section
      data-testid="sub-hero-section"
      className="relative min-h-[78svh] w-full overflow-hidden cgp-grain"
    >
      <div className="absolute inset-0">
        <img
          src={image}
          alt=""
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#051024]/95 via-[#051024]/85 to-[#0A1F44]/60" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#051024]/40 via-transparent to-[#051024]/70" />
      </div>

      <div className="relative cgp-container pt-36 pb-20 md:pt-44 md:pb-24 flex flex-col min-h-[78svh] justify-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="max-w-3xl"
        >
          <span className="cgp-overline" data-testid="sub-hero-overline">
            {overline}
          </span>

          <h1
            data-testid="sub-hero-title"
            className="font-serif font-light text-white mt-6 text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight"
          >
            {title}
          </h1>

          {description && (
            <p
              data-testid="sub-hero-description"
              className="mt-7 text-white/75 text-lg max-w-2xl leading-relaxed"
            >
              {description}
            </p>
          )}

          <div className="mt-10 flex flex-wrap items-center gap-4">
            {primaryCta && (
              <button
                data-testid="sub-hero-primary-cta"
                onClick={() => goTo(primaryCta.href)}
                className="cgp-btn-gold rounded-full px-7 py-3.5 inline-flex items-center gap-2 text-sm"
              >
                {primaryCta.label}
                <ArrowUpRight size={16} strokeWidth={2.2} />
              </button>
            )}
            {secondaryCta && (
              <button
                data-testid="sub-hero-secondary-cta"
                onClick={() => goTo(secondaryCta.href)}
                className="cgp-btn-ghost rounded-full px-7 py-3.5 inline-flex items-center gap-2 text-sm"
              >
                {secondaryCta.label}
              </button>
            )}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
